/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Partner_Admin_Commission_Paid_OnInputs */



/**
* | output |
* | --- |
* | "Paid {date}" |
*
* @param {Partner_Admin_Commission_Paid_OnInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_admin_commission_paid_on = /** @type {((inputs: Partner_Admin_Commission_Paid_OnInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Admin_Commission_Paid_OnInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Ausgezahlt ${i?.date}`)
	return /** @type {LocalizedString} */ (`Paid ${i?.date}`)
});